<template>
  <div class="cards-container">
    <div
      class="source-card"
      :class="{ 'card-selected': selection.enedis }"
      @click="toggleSource('enedis')"
    >
      <div class="card-content">
        <div
          class="selection-indicator"
          :class="{ 'active-indicator': selection.enedis }"
        >
          <v-icon v-if="selection.enedis" color="white">mdi-check</v-icon>
        </div>

        <h2 class="card-title">{{ $t("_compteur_enedis_") }}</h2>
        <p class="card-subtitle">
          {{
            $t(
              "_renseignez_le_numero_prm_de_l_installation_pour_une_demande_de_consentement_"
            )
          }}
        </p>

        <v-text-field
          :label="$t('_prm_') + ' (*)'"
          outlined
          dense
          v-model="prmEnedis"
          class="input-field"
          @input="updateAnswer"
          :disabled="!selection.enedis"
          hide-details
          color="black"
          @click.stop
        />

        <v-btn
          color="orange"
          class="white--text font-weight-bold validation-button"
          large
          @click.stop="validateConfidentiality"
        >
          {{ $t("_soumettre_ENEDIS_") }}
        </v-btn>
      </div>
    </div>

    <div
      class="source-card"
      :class="{ 'card-selected': selection.solaredge }"
      @click="toggleSource('solaredge')"
    >
      <div class="card-content">
        <div
          class="selection-indicator"
          :class="{ 'active-indicator': selection.solaredge }"
        >
          <v-icon v-if="selection.solaredge" color="white">mdi-check</v-icon>
        </div>

        <h2 class="card-title">{{ $t("_onduleurs_solaredge_") }}</h2>
        <p class="card-subtitle">
          {{ $t("_renseignez_vos_cles_d_acces_aux_donnees_onduleurs_") }}
        </p>

        <v-text-field
          :label="$t('_site_id_') + ' (*)'"
          outlined
          dense
          v-model="solaredgeSiteId"
          class="input-field mb-3"
          @input="updateAnswer"
          :disabled="!selection.solaredge"
          hide-details
          color="black"
          @click.stop
        />

        <v-text-field
          :label="$t('_api_key_') + ' (*)'"
          outlined
          dense
          v-model="solaredgeApiKey"
          class="input-field"
          @input="updateAnswer"
          :disabled="!selection.solaredge"
          hide-details
          color="black"
          @click.stop
        />

        <v-btn
          color="orange"
          class="white--text font-weight-bold validation-button"
          large
          @click.stop="validateConfidentiality"
        >
          {{ $t("_soumettre_SolarEdge_") }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    install_id: { required: true },
    initDonnee: { required: false },
    prm: { required: false },
  },
  mounted() {
    if (this.prm) {
      this.prmEnedis = this.prm;
    }
    
    this.updateAnswer();
  },
  watch: {
  prm: {
    immediate: true,
    handler(val) {
      if (val) {
        this.prmEnedis = val;
       
      }
    }
  }
},
  data() {
    return {
     
      prmEnedis: "",
      solaredgeApiKey: "",
      solaredgeSiteId: "",
      selection: {
        enedis: true,
        solaredge: false,
      },
    };
  },
  methods: {
    toggleSource(source) {
      this.selection[source] = !this.selection[source];
      this.updateAnswer();
    },

    updateAnswer() {
      const answerData = {
        enedis: {
          selected: this.selection.enedis,
          prm: this.prmEnedis,
        },
        solaredge: {
          selected: this.selection.solaredge,
          siteId: this.solaredgeSiteId,
          apiKey: this.solaredgeApiKey,
        },
      };
      this.$emit("answer", answerData);
    },

    validateConfidentiality() {
      let isValid = true;
      let atLeastOneSelected =
        this.selection.enedis || this.selection.solaredge;
      let alertMessage =
        "Veuillez remplir les champs obligatoires (*) pour les sources sélectionnées.";

      if (!atLeastOneSelected) {
        isValid = false;
        alertMessage = "Veuillez sélectionner au moins une source de données.";
      }

      if (this.selection.enedis && this.prmEnedis.length === 0) {
        isValid = false;
      }

      if (
        this.selection.solaredge &&
        (this.solaredgeSiteId.length === 0 || this.solaredgeApiKey.length === 0)
      ) {
        isValid = false;
      }

      if (isValid) {
        this.$emit("enable");
        this.updateAnswer();
      } else {
        this.$emit("disable");
        alert(alertMessage);
      }
    },
  },
  
};
</script>

<style scoped>
/* Conteneur principal en Flex pour les cartes */
.cards-container {
  display: flex;
  gap: 20px; /* Espace entre les deux cartes */
  padding: 20px;
  width: 100%;
  max-width: 900px; /* Limite pour ne pas qu'elles soient trop larges */
  margin: auto; /* Centrage du conteneur */
}

/* Style de base pour chaque carte */
.source-card {
  min-height: 350px;
  flex: 1;
  background-color: #ffffff;
  border: 2px solid #e0e0e0; /* Bordure par défaut, subtile */
  border-radius: 12px;
  padding: 30px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* Ombre légère */
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center; /* Centrer le contenu horizontalement */
  text-align: center;
}

/* Style de la carte sélectionnée */
.source-card.card-selected {
  border-color: #ff9800; /* Orange vif pour la sélection */
  box-shadow: 0 8px 20px rgba(255, 152, 0, 0.2); /* Ombre orange élégante */
  background-color: #ffffff; /* Léger fond pour indiquer la sélection */
}

/* Contenu de la carte */
.card-content {
  width: 100%;
  max-width: 300px; /* Limite la largeur du contenu interne */
}

.card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  margin-top: 10px;
  margin-bottom: 5px;
}

.card-subtitle {
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 25px;
  min-height: 40px;
}

/* Indicateur de sélection stylisé (remplace la gommette) */
.selection-indicator {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #ff9800;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px; /* Espace avec le titre */
  transition: all 0.2s;
}

.active-indicator {
  background-color: #ff9800; /* Fond orange quand sélectionné */
  border-color: #ff9800;
}

/* Champ de texte */
.input-field {
  margin-top: 15px;
}

/* Responsive pour les petits écrans (mobile) */
@media (max-width: 768px) {
  .cards-container {
    flex-direction: column;
    gap: 15px;
    padding: 10px;
  }

  .source-card {
    padding: 25px;
  }
}

.validation-button {
  margin-top: 30px;
  width: 300px;
}

.validation-button span {
  text-transform: uppercase;
}
</style>
